// This function takes a date string as input and formats it as 'dd.mm.yyyy'.
export function formatDateString(inputDate: string): string {
    const date = new Date(inputDate);

    // Check if the date is valid by comparing it to NaN (Not a number)
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }
  
    // Extract the year, month, and day components from the Date object and format them.

    // Ensure year has 4 digits by padding with '0' if needed.
    const year = date.getFullYear().toString().padStart(4, '0');

    // Ensure month and day has 2 digits by padding with '0' if needed.
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${day}.${month}.${year}`;
}

export function isValidDateTime(dateString: string) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
       return false;
    }
    return date.getFullYear() > 9000;
}
  
/* Three-letter month names, fixed rather than taken from the runtime's locale data.
   toLocaleDateString('en-GB', { month: 'short' }) renders September as 'Sept' on current ICU, which
   would disagree with the licensing service's own invoice line for the same period - that is
   formatted against the invariant culture and says 'Sep'. The customer sees both, so they have to
   match, and pinning the table also makes the output immune to an ICU update changing it again. */
const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Formats a date as 'd MMM yyyy' — e.g. '17 Dec 2026'.
 *
 * Distinct from formatDateString's 'dd.mm.yyyy' because the payment dialogs show dates inside a
 * sentence ("starting on 18 Sep 2026", "17 Dec 2026 – 1 Jan 2027"), where a numeric form reads as a
 * code rather than a date.
 *
 * @param inputDate Date string to format.
 * @returns The formatted date, or 'Invalid Date' when the input cannot be parsed.
 */
export function formatDayMonthYear(inputDate: string): string {
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }

    return `${date.getDate()} ${SHORT_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
